@if (hrisIntegrationDataService.hrisIntegration; as hrisIntegration) {
  <div
    class="flex h-full flex-col justify-between gap-5 rounded-lg border px-4 py-5"
    [class]="cardClass"
  >
    <div class="flex flex-col gap-2">
      <div class="flex justify-between gap-6">
        <div class="flex flex-col gap-2">
          <div class="flex gap-2">
            <mat-icon
              class="material-icons-outlined hvs-icon-xxl text-blue-dark"
            >
              link
            </mat-icon>
            <p class="text-base font-semibold text-blue-dark">
              {{ hrisIntegration.providerName }}
            </p>
          </div>
          <div class="flex gap-2">
            <div class="flex flex-col gap-1">
              <span>
                {{ 'portal.hrisIntegration.card.syncStatus' | transloco }}:
              </span>
              <span>
                {{
                  'portal.hrisIntegration.card.numberOfSyncedUsers' | transloco
                }}:
              </span>
            </div>
            <div class="flex flex-col justify-between gap-1">
              <span class="font-semibold" [class]="statusClass">
                {{
                  'portal.hrisIntegration.statuses.' + hrisIntegration.status
                    | transloco
                }}
              </span>
              <span class="font-semibold">
                {{ hrisIntegration.numberOfSyncedUsers || 0 }}
              </span>
            </div>
          </div>
        </div>
        <app-primary-button
          [text]="'portal.hrisIntegration.card.syncNowButton' | transloco"
          [loading]="hrisIntegrationDataService.isSyncingUsers"
          [disabled]="
            hrisIntegrationDataService.isDeletingHRISIntegration ||
            hrisIntegrationDataService.isLoadingHRISIntegration
          "
          icon="sync"
          class="shrink-0"
          [matTooltip]="lastSyncedAtTooltip"
          (buttonClicked)="onSyncNowButtonClick()"
        />
      </div>
      <p class="text-sm font-normal text-grey">
        {{ 'portal.hrisIntegration.card.text' | transloco }}
      </p>
    </div>
    <div class="flex gap-4">
      <app-text-button
        (click)="onFiltersButtonClick()"
        [disabled]="
          hrisIntegrationDataService.isSyncingUsers ||
          hrisIntegrationDataService.isDeletingHRISIntegration
        "
        [isLoading]="hrisIntegrationDataService.isLoadingHRISIntegration"
      >
        {{ 'portal.hrisIntegration.card.filtersButton' | transloco }}
        ({{ hrisIntegrationDataService.filtersCount }})
      </app-text-button>
      <app-text-button
        (click)="onDeleteButtonClick()"
        [disabled]="
          hrisIntegrationDataService.isSyncingUsers ||
          hrisIntegrationDataService.isLoadingHRISIntegration
        "
        [isLoading]="hrisIntegrationDataService.isDeletingHRISIntegration"
      >
        <ng-template let-isLoading="isLoading" let-disabled="disabled">
          <div class="flex gap-1 align-middle">
            {{ 'portal.hrisIntegration.card.deleteButton' | transloco }}
            <mat-icon
              class="hvs-icon-lg"
              [ngClass]="{
                'text-blue': !isLoading && !disabled,
                'text-grey': isLoading || disabled,
              }"
            >
              delete_forever
            </mat-icon>
          </div>
        </ng-template>
      </app-text-button>
    </div>
  </div>
} @else {
  <app-hris-integration-setup-card />
}
